import RecorderIcon from '@/components/Icon/RecorderIcon';
import { useCardMainMedia } from '@/hooks/cards/useCards';
import cn from '@/lib/cs';
import { useInView } from 'framer-motion';
import { ComponentProps, useRef, useState } from 'react';

import styles from './MainUserMedia.module.sass';

const MainUserMedia = ({
	speciesId,
	isThumbnail,
	className,
	tryIndex,
	...props
}: ComponentProps<'img'> & {
	speciesId: number;
	isThumbnail?: boolean;
	tryIndex?: number;
}) => {
	const containerRef = useRef<HTMLImageElement>(null);
	const isInView = useInView(containerRef, {
		once: true,
		margin: '50% 50% 50% 50%',
	});

	const [isLoaded, setIsLoaded] = useState(false);

	const { isUserPhotoAvailable, mainUserPhoto, isUserAudioAvailable } =
		useCardMainMedia(
			speciesId ?? 0,
			['photo', 'audio'],
			isThumbnail,
			isInView,
			tryIndex,
		);

	return (
		<div
			ref={containerRef}
			className="absolute inset-0 flex size-full items-center justify-center">
			{isUserAudioAvailable && !isUserPhotoAvailable && (
				<>
					<div className="absolute inset-0 size-full bg-secondary opacity-70" />
					<RecorderIcon className="relative size-16 text-white lg:size-24" />
					<p className="sr-only">Met jouw opname</p>
				</>
			)}
			{!!mainUserPhoto && (
				<img
					src={mainUserPhoto ?? ''}
					alt="Laatste foto uit jouw verzameling"
					onLoad={() => setIsLoaded(true)}
					className={cn(
						'size-full object-cover object-center',
						styles['MainUserMedia__Photo'],
						isLoaded && styles['MainUserMedia__Photo--loaded'],
						className,
					)}
					{...props}
				/>
			)}
		</div>
	);
};

export default MainUserMedia;
